(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Animate value cards on scroll
  const valueCards = document.querySelectorAll('.value-card');
  const teamMembers = document.querySelectorAll('.team-member');
  const statItems = document.querySelectorAll('.stat-item');

  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  // Animate value cards
  valueCards.forEach(function(card, index) {
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px)';
    card.style.transition = `all 0.6s ease ${index * 0.1}s`;
    observer.observe(card);
  });

  // Animate team members
  teamMembers.forEach(function(member, index) {
    member.style.opacity = '0';
    member.style.transform = 'translateY(30px)';
    member.style.transition = `all 0.6s ease ${index * 0.1}s`;
    observer.observe(member);
  });

  // Animate stats
  statItems.forEach(function(stat, index) {
    stat.style.opacity = '0';
    stat.style.transform = 'translateY(30px)';
    stat.style.transition = `all 0.6s ease ${index * 0.1}s`;
    observer.observe(stat);
  });

  // Counter animation for stats
  const statNumbers = document.querySelectorAll('.stat-number');
  
  statNumbers.forEach(function(statNumber) {
    const finalNumber = statNumber.textContent;
    const isPercentage = finalNumber.includes('%');
    const isPlus = finalNumber.includes('+');
    const isSlash = finalNumber.includes('/');
    
    if (!isPercentage && !isPlus && !isSlash) {
      const targetNumber = parseInt(finalNumber.replace(/\D/g, ''));
      
      if (targetNumber) {
        let currentNumber = 0;
        const increment = targetNumber / 50;
        const timer = setInterval(function() {
          currentNumber += increment;
          if (currentNumber >= targetNumber) {
            currentNumber = targetNumber;
            clearInterval(timer);
          }
          statNumber.textContent = Math.floor(currentNumber);
        }, 30);
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addresses"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Toggle add address form
  var addToggle = document.getElementById('add-address-toggle');
  var addForm = document.getElementById('add-address-form');

  if (addToggle && addForm) {
    addToggle.addEventListener('click', function() {
      if (addForm.style.display === 'none') {
        addForm.style.display = 'block';
        addForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        addForm.style.display = 'none';
      }
    });
  }

  // Initialize country/province selectors
  if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
    new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {
      hideElement: 'address_province_new'
    });

    // Initialize selectors for each existing address edit form
    var addressForms = document.querySelectorAll('.addresses-edit-form');
    addressForms.forEach(function(form) {
      var id = form.id.replace('address-edit-', '');
      var countryEl = document.getElementById('address_country_' + id);
      var provinceEl = document.getElementById('address_province_' + id);
      if (countryEl && provinceEl) {
        new Shopify.CountryProvinceSelector('address_country_' + id, 'address_province_' + id, {
          hideElement: 'address_province_' + id
        });
      }
    });
  }
});

// Toggle edit form visibility
function toggleEditForm(addressId) {
  var display = document.getElementById('address-display-' + addressId);
  var edit = document.getElementById('address-edit-' + addressId);

  if (display && edit) {
    if (edit.style.display === 'none') {
      edit.style.display = 'block';
      display.style.display = 'none';
    } else {
      edit.style.display = 'none';
      display.style.display = 'block';
    }
  }
}

// Delete address with confirmation
function deleteAddress(button) {
  var url = button.getAttribute('data-address-url');
  var confirmMsg = button.getAttribute('data-confirm');

  if (confirm(confirmMsg)) {
    if (typeof Shopify !== 'undefined' && Shopify.CustomerAddress) {
      Shopify.CustomerAddress.destroy(url);
    }
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Quantity controls
  const quantityButtons = document.querySelectorAll('[data-quantity-plus], [data-quantity-minus]');
  
  quantityButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const input = this.parentElement.querySelector('[data-quantity-input]');
      const currentValue = parseInt(input.value) || 0;
      const isPlus = this.hasAttribute('data-quantity-plus');
      
      let newValue = isPlus ? currentValue + 1 : Math.max(0, currentValue - 1);
      input.value = newValue;
      
      // Trigger change event
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Auto-submit on quantity change
  const quantityInputs = document.querySelectorAll('[data-quantity-input]');
  
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      // Auto-submit form when quantity changes
      const form = this.closest('form');
      if (form) {
        form.submit();
      }
    });
  });

  // Remove item confirmation
  const removeLinks = document.querySelectorAll('[data-cart-remove]');
  
  removeLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      if (!confirm('Are you sure you want to remove this item from your cart?')) {
        e.preventDefault();
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["checkout"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll to checkout features
  const checkoutFeatures = document.querySelector('.checkout-features');
  if (checkoutFeatures) {
    checkoutFeatures.style.opacity = '0';
    checkoutFeatures.style.transform = 'translateY(20px)';
    
    setTimeout(function() {
      checkoutFeatures.style.transition = 'all 0.6s ease';
      checkoutFeatures.style.opacity = '1';
      checkoutFeatures.style.transform = 'translateY(0)';
    }, 200);
  }

  // Animate checkout features on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  // Observe checkout features
  const features = document.querySelectorAll('.checkout-feature');
  features.forEach(function(feature, index) {
    feature.style.opacity = '0';
    feature.style.transform = 'translateY(20px)';
    feature.style.transition = `all 0.6s ease ${index * 0.1}s`;
    observer.observe(feature);
  });

  // Form submission feedback
  const notesForm = document.querySelector('.checkout-notes-form');
  if (notesForm) {
    notesForm.addEventListener('submit', function() {
      const submitBtn = this.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Saving...';
      submitBtn.disabled = true;
      
      setTimeout(function() {
        submitBtn.textContent = 'Saved!';
        setTimeout(function() {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 1000);
      }, 500);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Form validation
  const contactForm = document.querySelector('.contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
      const requiredFields = this.querySelectorAll('[required]');
      let isValid = true;
      
      requiredFields.forEach(function(field) {
        if (!field.value.trim()) {
          field.style.borderColor = '#ff4444';
          isValid = false;
        } else {
          field.style.borderColor = '';
        }
      });
      
      if (!isValid) {
        e.preventDefault();
        alert('Please fill in all required fields.');
      }
    });

    // Real-time validation
    const inputs = contactForm.querySelectorAll('input, select, textarea');
    inputs.forEach(function(input) {
      input.addEventListener('blur', function() {
        if (this.hasAttribute('required') && !this.value.trim()) {
          this.style.borderColor = '#ff4444';
        } else {
          this.style.borderColor = '';
        }
      });
    });
  }

  // Smooth animations
  const contactItems = document.querySelectorAll('.contact-info-item, .social-link');
  contactItems.forEach(function(item, index) {
    item.style.opacity = '0';
    item.style.transform = 'translateY(20px)';
    item.style.transition = `all 0.6s ease ${index * 0.1}s`;
    
    setTimeout(function() {
      item.style.opacity = '1';
      item.style.transform = 'translateY(0)';
    }, 200 + (index * 100));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class Footer {
    constructor() {
      this.newsletterForm = document.getElementById('footer-newsletter-form');
      this.init();
    }
    
    init() {
      this.setupNewsletter();
    }
    
    setupNewsletter() {
      if (!this.newsletterForm) return;
      
      this.newsletterForm.addEventListener('submit', (e) => {
        e.preventDefault();
        
        const emailInput = this.newsletterForm.querySelector('input[type="email"]');
        const email = emailInput.value.trim();
        
        if (!email) {
          this.showMessage('Please enter a valid email address.', 'error');
          return;
        }
        
        // Here you would typically send the email to your backend
        // For now, we'll just show a success message
        this.showMessage('Thank you for subscribing!', 'success');
        emailInput.value = '';
      });
    }
    
    showMessage(message, type) {
      // Remove existing messages
      const existingMessage = this.newsletterForm.querySelector('.footer__newsletter-message');
      if (existingMessage) {
        existingMessage.remove();
      }
      
      // Create new message
      const messageEl = document.createElement('div');
      messageEl.className = `footer__newsletter-message footer__newsletter-message--${type}`;
      messageEl.textContent = message;
      
      // Insert after the form
      this.newsletterForm.parentNode.insertBefore(messageEl, this.newsletterForm.nextSibling);
      
      // Remove message after 5 seconds
      setTimeout(() => {
        if (messageEl.parentNode) {
          messageEl.remove();
        }
      }, 5000);
    }
  }
  
  // Initialize footer when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new Footer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Tab switching
  const tabs = document.querySelectorAll('.login-tab');
  const formContainers = document.querySelectorAll('.login-form-container');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const targetTab = this.getAttribute('data-tab');
      
      // Update active tab
      tabs.forEach(function(t) {
        t.classList.remove('active');
      });
      this.classList.add('active');
      
      // Show corresponding form
      formContainers.forEach(function(container) {
        container.classList.remove('active');
      });
      
      const targetForm = document.getElementById(targetTab + '-form');
      if (targetForm) {
        targetForm.classList.add('active');
      }
    });
  });

  // Password toggle functionality
  const passwordToggles = document.querySelectorAll('.password-toggle');
  
  passwordToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      const input = document.getElementById(targetId);
      const eyeIcon = this.querySelector('.eye-icon');
      const eyeOffIcon = this.querySelector('.eye-off-icon');
      
      if (input.type === 'password') {
        input.type = 'text';
        eyeIcon.style.display = 'none';
        eyeOffIcon.style.display = 'block';
      } else {
        input.type = 'password';
        eyeIcon.style.display = 'block';
        eyeOffIcon.style.display = 'none';
      }
    });
  });

  // Form validation
  const forms = document.querySelectorAll('.login-form');
  
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      const requiredFields = this.querySelectorAll('[required]');
      let isValid = true;
      
      requiredFields.forEach(function(field) {
        if (!field.value.trim()) {
          field.style.borderColor = '#ff4444';
          isValid = false;
        } else {
          field.style.borderColor = '';
        }
      });
      
      if (!isValid) {
        e.preventDefault();
        alert('Please fill in all required fields.');
      }
    });

    // Real-time validation
    const inputs = form.querySelectorAll('input');
    inputs.forEach(function(input) {
      input.addEventListener('blur', function() {
        if (this.hasAttribute('required') && !this.value.trim()) {
          this.style.borderColor = '#ff4444';
        } else {
          this.style.borderColor = '';
        }
      });
    });
  });

  // Social login buttons
  const socialButtons = document.querySelectorAll('.social-login-btn');
  
  socialButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const provider = this.getAttribute('data-provider');
      // Add social login logic here
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Smooth scrolling for table of contents links
  const tocLinks = document.querySelectorAll('.privacy-toc-link');
  
  tocLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
        // Update active link
        tocLinks.forEach(function(l) {
          l.classList.remove('active');
        });
        this.classList.add('active');
      }
    });
  });

  // Highlight current section in TOC
  const sections = document.querySelectorAll('.privacy-section');
  const observerOptions = {
    threshold: 0.3,
    rootMargin: '-100px 0px -50% 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        const sectionId = entry.target.id;
        const correspondingLink = document.querySelector(`.privacy-toc-link[href="#${sectionId}"]`);
        
        if (correspondingLink) {
          tocLinks.forEach(function(link) {
            link.classList.remove('active');
          });
          correspondingLink.classList.add('active');
        }
      }
    });
  }, observerOptions);

  sections.forEach(function(section) {
    observer.observe(section);
  });

  // Print functionality
  const printButton = document.createElement('button');
  printButton.textContent = 'Print Privacy Policy';
  printButton.className = 'btn btn--secondary privacy-print-btn';
  printButton.style.marginTop = '2rem';
  
  printButton.addEventListener('click', function() {
    window.print();
  });

  const privacyContent = document.querySelector('.privacy-content');
  if (privacyContent) {
    privacyContent.appendChild(printButton);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPage {
    constructor() {
      this.form = document.querySelector('.fragrance-product__form-element');
      this.variantIdInput = document.querySelector('.fragrance-product__variant-id');
      this.quantityInput = document.querySelector('.fragrance-product__quantity-input');
      this.addToCartBtn = document.querySelector('.fragrance-product__add-to-cart');
      this.priceElement = document.querySelector('.fragrance-product__price');
      this.stockElement = document.querySelector('.fragrance-product__stock');
      
      // Safely get product data from script tag
      try {
        const productDataScript = document.getElementById('product-data');
        this.productData = productDataScript ? JSON.parse(productDataScript.textContent) : {};
        this.variants = this.productData.variants || [];
      } catch (error) {
        console.error('Error parsing product data:', error);
        this.productData = {};
        this.variants = [];
      }
      
      this.init();
    }
    
    init() {
      this.setupQuantityControls();
      this.setupVariantSelection();
      this.setupMediaGallery();
      this.setupRelatedProductsCarousel();
      this.setupExpandableDetails();
      this.updateVariant();
    }
    
    setupQuantityControls() {
      const decreaseBtn = document.querySelector('[data-action="decrease"]');
      const increaseBtn = document.querySelector('[data-action="increase"]');
      
      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', () => {
          const currentValue = parseInt(this.quantityInput.value) || 1;
          if (currentValue > 1) {
            this.quantityInput.value = currentValue - 1;
          }
        });
      }
      
      if (increaseBtn) {
        increaseBtn.addEventListener('click', () => {
          const currentValue = parseInt(this.quantityInput.value) || 1;
          this.quantityInput.value = currentValue + 1;
        });
      }
    }
    
    setupVariantSelection() {
      const optionInputs = document.querySelectorAll('.product-form__option-input');
      
      optionInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.updateVariant();
        });
      });
    }
    
    setupMediaGallery() {
      this.currentSlide = 0;
      this.slides = document.querySelectorAll('.fragrance-product__slide');
      this.thumbnails = document.querySelectorAll('.fragrance-product__thumbnail');
      this.prevBtn = document.querySelector('.fragrance-product__nav--prev');
      this.nextBtn = document.querySelector('.fragrance-product__nav--next');
      
      // Only setup carousel if we have slides
      if (this.slides.length === 0) {
        return;
      }
      
      // Setup thumbnail navigation
      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          this.goToSlide(index);
        });
      });
      
      // Setup arrow navigation
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.previousSlide();
        });
      }
      
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.nextSlide();
        });
      }
      
      // Setup keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          this.nextSlide();
        }
      });
      
      // Setup touch/swipe support
      this.setupTouchSupport();
    }
    
    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;
      
      // Update slides
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
      
      // Update thumbnails
      this.thumbnails.forEach((thumbnail, i) => {
        thumbnail.classList.toggle('active', i === index);
      });
      
      this.currentSlide = index;
    }
    
    nextSlide() {
      const nextIndex = (this.currentSlide + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }
    
    previousSlide() {
      const prevIndex = this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
      this.goToSlide(prevIndex);
    }
    
    setupTouchSupport() {
      const carousel = document.querySelector('.fragrance-product__main-image');
      if (!carousel) return;
      
      let startX = 0;
      let endX = 0;
      
      carousel.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });
      
      carousel.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].clientX;
        this.handleSwipe(startX, endX);
      });
    }
    
    handleSwipe(startX, endX) {
      const threshold = 50; // Minimum swipe distance
      const diff = startX - endX;
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // Swipe left - next slide
          this.nextSlide();
        } else {
          // Swipe right - previous slide
          this.previousSlide();
        }
      }
    }
    
    updateVariant() {
      const selectedOptions = this.getSelectedOptions();
      const variant = this.findVariant(selectedOptions);
      
      if (variant) {
        this.variantIdInput.value = variant.id;
        this.updatePrice(variant);
        this.updateStock(variant);
        this.updateAddToCartButton(variant);
      }
    }
    
    getSelectedOptions() {
      const options = {};
      const optionInputs = document.querySelectorAll('.fragrance-product__option-input:checked');
      
      optionInputs.forEach(input => {
        const optionName = input.name.match(/options\[(.*?)\]/)[1];
        options[optionName] = input.value;
      });
      
      return options;
    }
    
    findVariant(selectedOptions) {
      return this.variants.find(variant => {
        return variant.options.every((option, index) => {
          const optionName = this.productData.options[index].name;
          return selectedOptions[optionName] === option;
        });
      });
    }
    
    updatePrice(variant) {
      if (!this.priceElement) return;
      
      const comparePrice = variant.compare_at_price;
      const price = variant.price;
      
      if (comparePrice && comparePrice > price) {
        this.priceElement.innerHTML = `
          <span class="fragrance-product__price-compare">${this.formatMoney(comparePrice)}</span>
          <span class="fragrance-product__price-sale">${this.formatMoney(price)}</span>
          <span class="fragrance-product__price-badge">Sale</span>
        `;
      } else {
        this.priceElement.innerHTML = `
          <span class="fragrance-product__price-regular">${this.formatMoney(price)}</span>
        `;
      }
    }
    
    updateStock(variant) {
      if (!this.stockElement) return;
      
      const stockStatus = this.stockElement.querySelector('.fragrance-product__stock-status');
      
      if (variant.inventory_management === 'shopify') {
        if (variant.inventory_quantity <= 0 && variant.inventory_policy === 'deny') {
          // Remove stock status completely when sold out
          this.stockElement.innerHTML = '';
        } else if (variant.inventory_quantity <= 5 && variant.inventory_quantity > 0) {
          if (stockStatus) {
            stockStatus.textContent = `Only ${variant.inventory_quantity} left in stock`;
            stockStatus.className = 'fragrance-product__stock-status fragrance-product__stock-status--low';
          } else {
            this.stockElement.innerHTML = `<span class="fragrance-product__stock-status fragrance-product__stock-status--low">Only ${variant.inventory_quantity} left in stock</span>`;
          }
        } else {
          this.stockElement.innerHTML = '';
        }
      } else {
        this.stockElement.innerHTML = '';
      }
    }
    
    updateAddToCartButton(variant) {
      if (!this.addToCartBtn) return;
      
      if (variant.available) {
        this.addToCartBtn.textContent = 'Add to Cart';
        this.addToCartBtn.disabled = false;
      } else {
        this.addToCartBtn.textContent = 'Sold Out';
        this.addToCartBtn.disabled = true;
      }
    }
    
    formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(cents / 100);
    }
    
    setupRelatedProductsCarousel() {
      this.relatedTrack = document.getElementById('related-track');
      this.relatedPrevBtn = document.getElementById('related-prev');
      this.relatedNextBtn = document.getElementById('related-next');
      
      if (!this.relatedTrack || !this.relatedPrevBtn || !this.relatedNextBtn) {
        return;
      }
      
      this.relatedItems = this.relatedTrack.querySelectorAll('.related-product-item');
      
      this.relatedCurrentIndex = 0;
      this.relatedItemsPerView = this.getItemsPerView();
      this.relatedMaxIndex = Math.max(0, this.relatedItems.length - this.relatedItemsPerView);
      
      
      // Setup navigation
      this.relatedPrevBtn.addEventListener('click', () => {
        this.relatedPreviousSlide();
      });
      
      this.relatedNextBtn.addEventListener('click', () => {
        this.relatedNextSlide();
      });
      
      // Setup touch/swipe support
      this.setupRelatedTouchSupport();
      
      // Setup responsive behavior
      window.addEventListener('resize', () => {
        this.relatedItemsPerView = this.getItemsPerView();
        this.relatedMaxIndex = Math.max(0, this.relatedItems.length - this.relatedItemsPerView);
        this.relatedCurrentIndex = Math.min(this.relatedCurrentIndex, this.relatedMaxIndex);
        this.updateRelatedCarousel();
      });
      
      // If we have 3 or fewer products, show them all without carousel
      if (this.relatedItems.length <= 3) {
        this.relatedItemsPerView = this.relatedItems.length;
        this.relatedMaxIndex = 0;
        this.relatedCurrentIndex = 0;
        // Hide navigation buttons for small product sets
        if (this.relatedPrevBtn) this.relatedPrevBtn.style.display = 'none';
        if (this.relatedNextBtn) this.relatedNextBtn.style.display = 'none';
      }
      
      // Initial position
      this.updateRelatedCarousel();
    }
    
    getItemsPerView() {
      const trackWidth = this.relatedTrack.offsetWidth;
      const itemWidth = 300; // Match CSS flex: 0 0 300px
      const gap = 40; // Match CSS gap: 2.5rem = 40px
      const itemsPerView = Math.floor(trackWidth / (itemWidth + gap));
      return Math.max(1, itemsPerView); // Always show at least 1 item
    }
    
    relatedNextSlide() {
      if (this.relatedCurrentIndex < this.relatedMaxIndex) {
        this.relatedCurrentIndex++;
        this.updateRelatedCarousel();
      }
    }
    
    relatedPreviousSlide() {
      if (this.relatedCurrentIndex > 0) {
        this.relatedCurrentIndex--;
        this.updateRelatedCarousel();
      }
    }
    
    updateRelatedCarousel() {
      if (!this.relatedTrack) return;
      
      const itemWidth = 300; // Match CSS flex: 0 0 300px
      const gap = 40; // Match CSS gap: 2.5rem = 40px
      const translateX = -(this.relatedCurrentIndex * (itemWidth + gap));
      
      this.relatedTrack.style.transform = `translateX(${translateX}px)`;
      
      // Update navigation button states
      if (this.relatedPrevBtn) {
        this.relatedPrevBtn.style.opacity = this.relatedCurrentIndex === 0 ? '0.5' : '1';
        this.relatedPrevBtn.style.pointerEvents = this.relatedCurrentIndex === 0 ? 'none' : 'auto';
      }
      
      if (this.relatedNextBtn) {
        this.relatedNextBtn.style.opacity = this.relatedCurrentIndex >= this.relatedMaxIndex ? '0.5' : '1';
        this.relatedNextBtn.style.pointerEvents = this.relatedCurrentIndex >= this.relatedMaxIndex ? 'none' : 'auto';
      }
    }
    
    setupRelatedTouchSupport() {
      if (!this.relatedTrack) return;
      
      let startX = 0;
      let endX = 0;
      
      this.relatedTrack.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });
      
      this.relatedTrack.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].clientX;
        this.handleRelatedSwipe(startX, endX);
      });
    }
    
    handleRelatedSwipe(startX, endX) {
      const threshold = 50; // Minimum swipe distance
      const diff = startX - endX;
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // Swipe left - next slide
          this.relatedNextSlide();
        } else {
          // Swipe right - previous slide
          this.relatedPreviousSlide();
        }
      }
    }

    setupExpandableDetails() {
      const accordionHeaders = document.querySelectorAll('.fragrance-product__accordion-header');

      accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
          const targetAccordion = header.getAttribute('data-accordion');
          const content = document.querySelector(`[data-content="${targetAccordion}"]`);
          
          // Toggle current accordion
          const isActive = header.classList.contains('active');
          
          if (isActive) {
            // Close current accordion
            header.classList.remove('active');
            content.classList.remove('active');
          } else {
            // Close all other accordions
            accordionHeaders.forEach(h => h.classList.remove('active'));
            document.querySelectorAll('.fragrance-product__accordion-content').forEach(c => c.classList.remove('active'));
            
            // Open current accordion
            header.classList.add('active');
            content.classList.add('active');
          }
        });
      });
    }
  }
  
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    try {
      new ProductPage();
    } catch (error) {
      console.error('Error initializing ProductPage:', error);
    }

    // Lightbox
    const lightbox = document.getElementById('product-lightbox');
    const lightboxImg = document.getElementById('lightbox-image');
    const lightboxCounter = document.getElementById('lightbox-counter');
    const slides = document.querySelectorAll('.fragrance-product__slide[data-lightbox-src]');
    let lightboxIndex = 0;

    function openLightbox(index) {
      if (!lightbox || !slides.length) return;
      lightboxIndex = index;
      updateLightbox();
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }

    function updateLightbox() {
      const slide = slides[lightboxIndex];
      if (!slide || !lightboxImg) return;
      lightboxImg.src = slide.dataset.lightboxSrc;
      lightboxImg.alt = slide.dataset.lightboxAlt || '';
      if (lightboxCounter) {
        lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + slides.length;
      }
    }

    slides.forEach((slide, i) => {
      slide.addEventListener('click', (e) => {
        if (e.target.closest('.fragrance-product__nav')) return;
        openLightbox(i);
      });
    });

    const closeBtn = document.getElementById('lightbox-close');
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

    const prevBtn = document.getElementById('lightbox-prev');
    const nextBtn = document.getElementById('lightbox-next');
    if (prevBtn) prevBtn.addEventListener('click', () => {
      lightboxIndex = (lightboxIndex - 1 + slides.length) % slides.length;
      updateLightbox();
    });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      lightboxIndex = (lightboxIndex + 1) % slides.length;
      updateLightbox();
    });

    if (lightbox) {
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', (e) => {
        if (!lightbox.classList.contains('active')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
        if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-banner"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer {
    constructor(element) {
      this.element = element;
      this.endDate = new Date(element.dataset.endDate).getTime();
      this.interval = null;
      this.init();
    }

    init() {
      this.updateCountdown();
      this.interval = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }

    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.endDate - now;

      if (distance < 0) {
        this.element.innerHTML = '<div class="countdown__expired">Sale Ended</div>';
        clearInterval(this.interval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const daysElement = this.element.querySelector('[data-days]');
      const hoursElement = this.element.querySelector('[data-hours]');
      const minutesElement = this.element.querySelector('[data-minutes]');
      const secondsElement = this.element.querySelector('[data-seconds]');

      if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
      if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
      if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
      if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
    }

    destroy() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  // Initialize countdown timers when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const countdownElements = document.querySelectorAll('.countdown');
    countdownElements.forEach(element => {
      new CountdownTimer(element);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const track = document.getElementById('related-products-track');
  const prevBtn = document.getElementById('related-products-prev');
  const nextBtn = document.getElementById('related-products-next');
  
  if (!track || !prevBtn || !nextBtn) return;
  
  let currentIndex = 0;
  const items = track.querySelectorAll('.related-products__item');
  const itemWidth = items[0] ? items[0].offsetWidth + 32 : 332; // 300px + 32px gap
  const visibleItems = Math.floor(track.parentElement.offsetWidth / itemWidth);
  const maxIndex = Math.max(0, items.length - visibleItems);
  
  function updateCarousel() {
    const translateX = -currentIndex * itemWidth;
    track.style.transform = `translateX(${translateX}px)`;
    
    prevBtn.style.display = currentIndex > 0 ? 'flex' : 'none';
    nextBtn.style.display = currentIndex < maxIndex ? 'flex' : 'none';
  }
  
  function nextSlide() {
    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  }
  
  function prevSlide() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  }
  
  // Event listeners
  nextBtn.addEventListener('click', nextSlide);
  prevBtn.addEventListener('click', prevSlide);
  
  // Touch/swipe support
  let startX = 0;
  let isDragging = false;
  
  track.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    isDragging = true;
  });
  
  track.addEventListener('touchmove', function(e) {
    if (!isDragging) return;
    e.preventDefault();
  });
  
  track.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    isDragging = false;
    
    const endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;
    
    if (Math.abs(diffX) > 50) {
      if (diffX > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
  });
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') {
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      nextSlide();
    }
  });
  
  // Initialize
  updateCarousel();
  
  // Handle window resize
  window.addEventListener('resize', function() {
    const newVisibleItems = Math.floor(track.parentElement.offsetWidth / itemWidth);
    const newMaxIndex = Math.max(0, items.length - newVisibleItems);
    
    if (currentIndex > newMaxIndex) {
      currentIndex = newMaxIndex;
    }
    
    updateCarousel();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  class SearchPage {
    constructor() {
      this.filtersSidebar = document.querySelector('.search-filters');
      this.filtersToggle = document.querySelector('#filters-toggle');
      this.closeFilters = document.querySelector('#close-filters');
      this.clearFilters = document.querySelector('#clear-filters');
      this.resultsGrid = document.querySelector('#search-results-grid');
      this.sortSelect = document.querySelector('#sort-select');
      
      this.init();
    }
    
    init() {
      this.setupFilters();
      this.setupSorting();
      this.setupMobileFilters();
    }
    
    setupFilters() {
      if (!this.filtersSidebar || !this.resultsGrid) return;
      
      // Filter checkboxes
      const filterInputs = this.filtersSidebar.querySelectorAll('input[type="checkbox"]');
      filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.applyFilters();
        });
      });
      
      // Price range inputs
      const priceInputs = this.filtersSidebar.querySelectorAll('.search-filter__price-input');
      priceInputs.forEach(input => {
        input.addEventListener('input', () => {
          this.applyFilters();
        });
      });
      
      // Clear filters button
      if (this.clearFilters) {
        this.clearFilters.addEventListener('click', () => {
          this.clearAllFilters();
        });
      }
    }
    
    setupSorting() {
      if (!this.sortSelect || !this.resultsGrid) return;
      
      this.sortSelect.addEventListener('change', (e) => {
        this.sortResults(e.target.value);
      });
    }
    
    setupMobileFilters() {
      if (!this.filtersToggle || !this.filtersSidebar) return;
      
      this.filtersToggle.addEventListener('click', () => {
        this.filtersSidebar.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
      
      if (this.closeFilters) {
        this.closeFilters.addEventListener('click', () => {
          this.filtersSidebar.classList.remove('active');
          document.body.style.overflow = '';
        });
      }
      
      // Close filters when clicking outside
      document.addEventListener('click', (e) => {
        if (this.filtersSidebar.classList.contains('active') && 
            !this.filtersSidebar.contains(e.target) && 
            !this.filtersToggle.contains(e.target)) {
          this.filtersSidebar.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
    
    applyFilters() {
      const productCards = this.resultsGrid?.querySelectorAll('.search-result-card');
      if (!productCards) return;
      
      productCards.forEach(card => {
        let show = true;
        
        // Type filter
        const typeCheckboxes = this.filtersSidebar?.querySelectorAll('input[name="type"]:checked');
        if (typeCheckboxes && typeCheckboxes.length > 0) {
          let typeMatch = false;
          typeCheckboxes.forEach(checkbox => {
            if (card.dataset.type === checkbox.value) {
              typeMatch = true;
            }
          });
          if (!typeMatch) show = false;
        }
        
        // Price filter
        const priceMin = document.getElementById('price-min');
        const priceMax = document.getElementById('price-max');
        if (priceMin && priceMax && card.dataset.price) {
          const productPrice = parseFloat(card.dataset.price) / 100; // Convert from cents
          const minPrice = parseFloat(priceMin.value) || 0;
          const maxPrice = parseFloat(priceMax.value) || Infinity;
          
          if (productPrice < minPrice || productPrice > maxPrice) {
            show = false;
          }
        }
        
        // Availability filter
        const availabilityCheckboxes = this.filtersSidebar?.querySelectorAll('input[name="availability"]:checked');
        if (availabilityCheckboxes && availabilityCheckboxes.length > 0) {
          let availabilityMatch = false;
          availabilityCheckboxes.forEach(checkbox => {
            if (checkbox.value === 'in-stock' && card.dataset.available === 'true') {
              availabilityMatch = true;
            }
            if (checkbox.value === 'on-sale' && card.querySelector('.price-compare')) {
              availabilityMatch = true;
            }
          });
          if (!availabilityMatch) show = false;
        }
        
        // Show/hide card
        if (show) {
          card.style.display = 'block';
          card.style.animation = 'fadeIn 0.3s ease';
        } else {
          card.style.display = 'none';
        }
      });
      
      // Update results count
      this.updateResultsCount();
    }
    
    sortResults(sortBy) {
      const productCards = Array.from(this.resultsGrid?.querySelectorAll('.search-result-card') || []);
      if (productCards.length === 0) return;
      
      productCards.sort((a, b) => {
        switch (sortBy) {
          case 'price-asc':
            return (parseFloat(a.dataset.price) || 0) - (parseFloat(b.dataset.price) || 0);
          case 'price-desc':
            return (parseFloat(b.dataset.price) || 0) - (parseFloat(a.dataset.price) || 0);
          case 'title-asc':
            return (a.dataset.title || '').localeCompare(b.dataset.title || '');
          case 'title-desc':
            return (b.dataset.title || '').localeCompare(a.dataset.title || '');
          default:
            return 0; // Keep original order for relevance
        }
      });
      
      // Re-append sorted cards
      productCards.forEach(card => {
        this.resultsGrid.appendChild(card);
      });
    }
    
    clearAllFilters() {
      // Clear all checkboxes
      const checkboxes = this.filtersSidebar?.querySelectorAll('input[type="checkbox"]');
      checkboxes?.forEach(checkbox => {
        checkbox.checked = false;
      });
      
      // Clear price inputs
      const priceInputs = this.filtersSidebar?.querySelectorAll('.search-filter__price-input');
      priceInputs?.forEach(input => {
        input.value = '';
      });
      
      // Show all cards
      const productCards = this.resultsGrid?.querySelectorAll('.search-result-card');
      productCards?.forEach(card => {
        card.style.display = 'block';
      });
      
      // Reset sort
      if (this.sortSelect) {
        this.sortSelect.value = 'relevance';
      }
      
      this.updateResultsCount();
    }
    
    updateResultsCount() {
      const visibleCards = this.resultsGrid?.querySelectorAll('.search-result-card[style*="block"], .search-result-card:not([style*="none"])');
      const count = visibleCards?.length || 0;
      
      // Update results count display if it exists
      const resultsCount = document.querySelector('.search-results-count');
      if (resultsCount) {
        const originalText = resultsCount.textContent;
        const newText = originalText.replace(/\d+/, count);
        resultsCount.textContent = newText;
      }
    }
  }
  
  // Initialize search page when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new SearchPage();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var tocLinks = document.querySelectorAll('.shipping-toc-link');

  tocLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = this.getAttribute('href').substring(1);
      var targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        tocLinks.forEach(function (l) { l.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  var sections = document.querySelectorAll('.shipping-section');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var correspondingLink = document.querySelector('.shipping-toc-link[href="#' + entry.target.id + '"]');
        if (correspondingLink) {
          tocLinks.forEach(function (l) { l.classList.remove('active'); });
          correspondingLink.classList.add('active');
        }
      }
    });
  }, { threshold: 0.3, rootMargin: '-100px 0px -50% 0px' });

  sections.forEach(function (section) { observer.observe(section); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terms"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Smooth scrolling for table of contents links
  const tocLinks = document.querySelectorAll('.terms-toc-link');
  
  tocLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
        // Update active link
        tocLinks.forEach(function(l) {
          l.classList.remove('active');
        });
        this.classList.add('active');
      }
    });
  });

  // Highlight current section in TOC
  const sections = document.querySelectorAll('.terms-section');
  const observerOptions = {
    threshold: 0.3,
    rootMargin: '-100px 0px -50% 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        const sectionId = entry.target.id;
        const correspondingLink = document.querySelector(`.terms-toc-link[href="#${sectionId}"]`);
        
        if (correspondingLink) {
          tocLinks.forEach(function(link) {
            link.classList.remove('active');
          });
          correspondingLink.classList.add('active');
        }
      }
    });
  }, observerOptions);

  sections.forEach(function(section) {
    observer.observe(section);
  });

  // Print functionality
  const printButton = document.createElement('button');
  printButton.textContent = 'Print Terms';
  printButton.className = 'btn btn--secondary terms-print-btn';
  printButton.style.marginTop = '2rem';
  
  printButton.addEventListener('click', function() {
    window.print();
  });

  const termsContent = document.querySelector('.terms-content');
  if (termsContent) {
    termsContent.appendChild(printButton);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-might-be-interested"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const track = document.getElementById('you-might-be-interested-track');
  const prevBtn = document.getElementById('you-might-be-interested-prev');
  const nextBtn = document.getElementById('you-might-be-interested-next');
  
  if (!track || !prevBtn || !nextBtn) return;
  
  let currentIndex = 0;
  const items = track.querySelectorAll('.you-might-be-interested__item');
  const itemWidth = items[0] ? items[0].offsetWidth + 32 : 332; // 300px + 32px gap
  const visibleItems = Math.floor(track.parentElement.offsetWidth / itemWidth);
  const maxIndex = Math.max(0, items.length - visibleItems);
  
  function updateCarousel() {
    const translateX = -currentIndex * itemWidth;
    track.style.transform = `translateX(${translateX}px)`;
    
    prevBtn.style.display = currentIndex > 0 ? 'flex' : 'none';
    nextBtn.style.display = currentIndex < maxIndex ? 'flex' : 'none';
  }
  
  function nextSlide() {
    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  }
  
  function prevSlide() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  }
  
  // Event listeners
  nextBtn.addEventListener('click', nextSlide);
  prevBtn.addEventListener('click', prevSlide);
  
  // Touch/swipe support
  let startX = 0;
  let isDragging = false;
  
  track.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    isDragging = true;
  });
  
  track.addEventListener('touchmove', function(e) {
    if (!isDragging) return;
    e.preventDefault();
  });
  
  track.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    isDragging = false;
    
    const endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;
    
    if (Math.abs(diffX) > 50) {
      if (diffX > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
  });
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') {
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      nextSlide();
    }
  });
  
  // Initialize
  updateCarousel();
  
  // Handle window resize
  window.addEventListener('resize', function() {
    const newVisibleItems = Math.floor(track.parentElement.offsetWidth / itemWidth);
    const newMaxIndex = Math.max(0, items.length - newVisibleItems);
    
    if (currentIndex > newMaxIndex) {
      currentIndex = newMaxIndex;
    }
    
    updateCarousel();
  });
});

  } catch(e) { console.error(e); }
})();
})();
